import React, { Component, Fragment } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { withApollo } from 'react-apollo';

class ProgressHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { onClick, title, back } = this.props;

    return (
      <Fragment>
        <div className="profile__header">
          <div className="profile__header--container container">
            {back ? (
              <FontAwesomeIcon
                className="profile__header--icon"
                icon={faArrowLeft}
                onClick={evt => {
                  onClick();
                  evt.stopPropagation();
                }}
              />
            ) : null}
            <div className={`profile__header--title ${back ? 'profile__header--title--margin-right' : ''}`}>
              {title}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withApollo(ProgressHeader);



// WEBPACK FOOTER //
// ./src/components/NewPayments/Header.js